"use strict";

angular.module("vendor")
.controller("AbstractSaleRepresentativeEditController", function(_this, $scope, SaleRepresentativeAssignmentFactory) {
    $scope.service = SaleRepresentativeAssignmentFactory;

    $scope.updateSingle = function(instance, service, scope) {
        var userVendorId = _this.userVendor.id;
        var instance_id = instance.id;
        var selected = !!instance.selected;

        service(userVendorId, selected, instance_id).$promise.then(function onSuccess(data) {
            instance = data;
            scope.selectedCount = (instance.selected) ? scope.selectedCount + 1 : scope.selectedCount - 1;
            scope.totalSelectedCount = (instance.selected) ? scope.totalSelectedCount + 1 : scope.totalSelectedCount - 1;
            updateCheckboxState(scope);
        });
    };

    $scope.setCheckboxState = function(data, scope) {
        scope.totalCount = data.pagination.count;
        scope.selectedCount = data.selected_count;
        updateCheckboxState(scope);
    };

    function updateCheckboxState(scope) {
        scope.selectAllCheckbox = !!scope.selectedCount;
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative-edit/abstract-sale-representative-edit.controller.js
// module id = 1004
// module chunks = 0